import AOS from "aos";
import "aos/dist/aos.css";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import Paginator from "component/shared/Paginator/Paginator";
import { END_POINTS } from "constants/APIConstant";
import React from "react";
import useSWR from "swr";
import "./Related.scss";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import { FormattedMessage, useIntl } from "react-intl";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import ChevronIcon from "../../svg-icons/chevron-icon";
import LabelLang from "component/LabelLang/label-lang";
import ReactGA from "react-ga4";

function Related() {
  const intl = useIntl();

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

  React.useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

    
  ReactGA.initialize(END_POINTS.TRACKING_ID)

  React.useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/related", title: "Related Page" });
  }, []);


  const [categoriesTabToggle, setCategoriesTabToggle] = React.useState(0);

  const [filters, setFilters] = React.useState(0);

  const tabCategory = (index, id) => {
    setCategoriesTabToggle(index);
    setFilters(id);
  };

  const categoriesData = useSWR({
    url: END_POINTS.WEBSITE_TYPES,
  });

  const sitesList = useSWR({
    url: END_POINTS.RELATED_WEBSITES,
  });

  const renderSitesCategory = () => {
    const sitesCategoryData =
      !categoriesData ||
      categoriesData.error ||
      categoriesData.isLoading ||
      categoriesData.data === undefined ||
      categoriesData.data.data === undefined
        ? []
        : categoriesData.data.data;
    const rendering = sitesCategoryData.map(
      ({ id, title, websiteTypeTranslation }, i) => {
        return (
          <li
            key={i}
            className={categoriesTabToggle === i + 1 ? "active" : "item"}
            onClick={() => tabCategory(i + 1, id)}
          >
            <LabelLang
              id="title"
              defaultValue={title}
              translations={websiteTypeTranslation}
            />
          </li>
        );
      }
    );
    const defaultPagnation = (
      <li
        className={categoriesTabToggle === 0 ? "active" : "item"}
        onClick={() => tabCategory(0, 0)}
      >
        <FormattedMessage id="all-sites" />{" "}
      </li>
    );
    const renderingList = [defaultPagnation, ...rendering];
    const paginatedList = <Paginator size={5}>{renderingList}</Paginator>;
    return paginatedList;
  };

  const renderSitesFilterById = () => {
    const sites =
      sitesList.error ||
      sitesList.isLoading ||
      sitesList.data === undefined ||
      sitesList.data.data === undefined
        ? []
        : sitesList.data.data;

    const rendering =
      Object.keys(sites.filter((el) => el.websiteTypeId === filters)).length >
      0 ? (
        <Paginator size={5}>
          {sites
            .filter((el) => el.websiteTypeId === filters)
            .map(
              (
                { websiteTypeId, title, link, relatedWebsiteTranslation },
                i
              ) => (
                <div key={i} className="row b-b">
                  <div className="col-12 col-lg-6">
                    <div className="item-q">
                      <ChevronIcon />
                      <span>
                        <LabelLang
                          id="title"
                          defaultValue={title}
                          translations={relatedWebsiteTranslation}
                        />
                      </span>
                    </div>
                  </div>
                  <div
                    className="col-12 col-lg-6"
                    style={{ overflow: "hidden" }}
                  >
                    <a
                      href={link.includes("//") ? link : `//${link}`}
                      // href={`//${link}`}
                      className="link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {link}
                    </a>
                  </div>
                </div>
              )
              // <div key={i} className="row b-b">
              //   <div className="col-12 col-lg-6">
              //     <div className="item-q">
              //       <i className="fas fa-chevron-left"> </i>
              //       <span>بوابة الحكومة المصرية</span>
              //     </div>
              //   </div>
              //   <div className="col-12 col-lg-6">
              //       <a href="" className="link">www.egypt.gov.eg</a>
              //   </div>
              // </div>
            )}
        </Paginator>
      ) : (
        <DataNotFound />
      );
    return rendering;
  };

  const renderAllSites = () => {
    const sites =
      sitesList.error ||
      sitesList.isLoading ||
      sitesList.data === undefined ||
      sitesList.data.data === undefined
        ? []
        : sitesList.data.data;

    const rendering =
      Object.keys(sites).length > 0 ? (
        <Paginator size={5}>
          {sites.map(
            ({ websiteTypeId, title, link, relatedWebsiteTranslation }, i) => (
              <div key={i} className="row b-b">
                <div className="col-12 col-lg-6">
                  <div className="item-q">
                    <ChevronIcon />
                    <span>
                      <LabelLang
                        id="title"
                        defaultValue={title}
                        translations={relatedWebsiteTranslation}
                      />
                    </span>
                  </div>
                </div>
                <div className="col-12 col-lg-6" style={{ overflow: "hidden" }}>
                  <a
                    href={link.includes("//") ? link : `//${link}`}
                    // href={`//${link}`}
                    className="link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {link}
                  </a>
                </div>
              </div>
            )
          )}
        </Paginator>
      ) : (
        <DataNotFound />
      );
    return rendering;
  };

  return (
    <ContentLoading isLoading={categoriesData.isLoading || sitesList.isLoading}>
      <InnerHeader
        breadcrumb={[
          {
            title: intl.formatMessage({ id: "related-websites" }),
            clickClass: true,
          },
        ]}
        title={intl.formatMessage({ id: "related-websites-title" })}
      />
      <div className="container">
        <div className="row mt-5">
          <div className="col-12 col-lg-4">
            <div
              className="searchBy-ob"
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-easing="ease-in-sine"
            >
              <h5>{intl.formatMessage({ id: "browse-sites-by-type" })}:</h5>
              <ul>{renderSitesCategory()}</ul>
            </div>
          </div>
          <div className="col-12 col-lg-8">
            <div
              className="news-tabs"
              data-aos="fade-right"
              data-aos-duration="1000"
              data-aos-easing="ease-in-sine"
            >
              <div
                className={
                  categoriesTabToggle === 0
                    ? "active-item-news-tabs"
                    : "item-news-tabs"
                }
              >
                <div className="body-news mb-5">
                  {Object.keys(renderAllSites()).length > 0 ? (
                    renderAllSites()
                  ) : (
                    <DataNotFound />
                  )}
                </div>
              </div>
              <div
                className={
                  categoriesTabToggle !== 0
                    ? "active-item-news-tabs"
                    : "item-news-tabs"
                }
              >
                <div className="body-news mb-5">
                  {Object.keys(renderSitesFilterById()).length > 0 ? (
                    renderSitesFilterById()
                  ) : (
                    <DataNotFound />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default Related;
